import React from 'react';

import classes from './MFormFieldWrap.module.scss';
import classNames from 'classnames';
import MTooltip from 'views/MTooltip/MTooltip';
import { IoMdInformationCircleOutline } from 'react-icons/io';
import { AiOutlineInfoCircle } from 'react-icons/ai';

type Props = {
  name?: string;
  displayName?: string;
  className?: string;
  descriptionTooltip?: string;
  error?: string | null;
  action?: JSX.Element | null;
  information?: string;
  displayNameClass?: string;
  errorClass?: string;
  tooltipClass?: string;
};

const MFormFieldWrapView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <div className={props.className}>
      {props.displayName || props.action ? (
        <div className={classes['display']}>
          {props.displayName ? (
            <label className={classNames(classes['title'], props.displayNameClass)} htmlFor={props.name}>
              {props.displayName}
              {props.descriptionTooltip ? (
                <MTooltip
                  text={props.descriptionTooltip}
                >
                  <AiOutlineInfoCircle className={classes['icon']} />
                </MTooltip>
              ) : null}
            </label>
          ) : null}
          {props.information ? (
            <MTooltip text={props.information}>
              <IoMdInformationCircleOutline size={14}></IoMdInformationCircleOutline>
            </MTooltip>
          ) : null}
          {props.action || null}
        </div>
      ) : null}
      {props.children}
      {props.error ? <span className={`${classes['error']} ${props.errorClass}`}>{props.error}</span> : null}
    </div>
  );
};

MFormFieldWrapView.displayName = 'MFormFieldWrapView';
MFormFieldWrapView.defaultProps = {};

export default MFormFieldWrapView;
